<div *ngIf="facilities">
  <div class="app-header">
    <div class="app-header-row">
      <app-zpax-logo></app-zpax-logo>

      <div class="header-controls">
        <span
          *ngIf="isShowCropFacilityDropdown && this.user?.issuperuser"
          class="control-label"
          >Corporation</span
        >
        <app-corporation-selector
          *ngIf="
            isShowCropFacilityDropdown &&
            corporations?.length &&
            (user?.issuperuser || user?.isPhysician)
          "
          [corporations]="corporations"
          [defaultCorporationId]="selectedCorporationId"
          (corporationSelected)="onCorporationSelected($event)"
        ></app-corporation-selector>

        <span class="control-label"  *ngIf="isShowCropFacilityDropdown && facilities && !this.inReportsView" >Facility</span>
        <app-facility-selector *ngIf="isShowCropFacilityDropdown && facilities && !this.inReportsView"
          [initialFacilityIdSelection]="selectedFacilityId" [facilities]="facilities"
          (facilityIdSelected)="updateFacilitySelection($event)"
          [facilityProviderNumber]="facilityProviderNumber">
        </app-facility-selector>

        <span class="control-label">ID</span>

        <mat-form-field appearance="outline">
          <input matInput [value]="'#' + facilityProviderNumber" [readonly]="true">
        </mat-form-field>

        <mat-form-field appearance="outline" class="cusror-pointer">
          <div class="flex flex-row space-between">
            <input
              matInput
              class="cursor-pointer"
              [value]="userDisplayName"
              [readonly]="true"
              [matMenuTriggerFor]="menu"
            >

            <mat-icon
              class="top-0 cursor-pointer"
              [matMenuTriggerFor]="menu"
            >
              keyboard_arrow_down
            </mat-icon>
          </div>

          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="onchangePassword()">
              <span>Change Password</span>
            </button>
            <button mat-menu-item (click)="logout()">
              <span>Logout</span>
            </button>
          </mat-menu>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
